import { IAmendment, IRegulation } from '../../contracts/amendment.contract';

const isHardware = (amendment: IAmendment) => amendment.OperationalOrHardware === 'HARDWARE';
const isOperational = (amendment: IAmendment) => amendment.OperationalOrHardware === 'OPERATIONAL';

/**
 * Default (showOperational = false): Hardware amendments only.
 * Toggle on: Hardware and Operational amendments.
 */
export const filterAmendmentsByOperationalOrHardware = (amendments: IAmendment[], showOperational: boolean): IAmendment[] => {
    return amendments.filter((amendment) => isHardware(amendment) || (showOperational && isOperational(amendment)));
};

export const filterRegulationByOperationalOrHardware = (regulation: IRegulation, showOperational: boolean): IRegulation | null => {
    const amendments = filterAmendmentsByOperationalOrHardware(regulation.Amendments ?? [], showOperational);
    if (amendments.length === 0) return null;
    return { ...regulation, Amendments: amendments };
};

export const filterRegulationsByOperationalOrHardware = (regulations: IRegulation[], showOperational: boolean): IRegulation[] => {
    return regulations
        .map((regulation) => filterRegulationByOperationalOrHardware(regulation, showOperational))
        .filter((regulation): regulation is IRegulation => regulation !== null);
};
